import { cn } from "../lib/utils";

const LOGO_LOCKUP_URL = "/images/logo-family.png";
const LOGO_MARK_URL = "/images/logo-family-mark.png";

export default function FamilyLogo({ compact = false, className = "" }) {
  if (compact) {
    return (
      <img
        src={LOGO_MARK_URL}
        alt="Family by Affidya"
        className={cn("h-12 w-12 shrink-0 object-contain", className)}
      />
    );
  }

  return (
    <img
      src={LOGO_LOCKUP_URL}
      alt="Family by Affidya"
      className={cn("h-12 w-auto object-contain object-left", className)}
    />
  );
}
